import UserNewsTipsFilter from './UserNewsTipsFilter'
export default UserNewsTipsFilter
